import { Injectable, NgModule } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import { createAnimation } from '@ionic/core';

import { GenericMessageAlertComponent } from '../components/generic-message-alert/generic-message-alert.component';
import { MatchMessageAlertComponent } from '../components/match-message-alert/match-message-alert.component';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UtilityService {
  private _isLoading: boolean = false;
  private _difficulty: string;
  isMatchmaking: boolean = false;
  private _matchWithFriend: boolean = false;
  private _dataToCancelInvite: any;
  public subStatusMatch: Subscription = new Subscription();
  isInGame: boolean;
  isAudioPlayed: boolean;

  constructor(
    private modalCtrl: ModalController,
    private _loadingCtrl: LoadingController,
    private router: Router,
    private firebaseFunction: AngularFireFunctions,
  ) {
    this.isInGame = false;
  }

  async presentGenericModal(title: string, body: string, isCorrect: boolean, navigate: string = undefined) {

    const modal = await this.modalCtrl.create({
      component: GenericMessageAlertComponent,
      cssClass: 'generic-message-alert',
      componentProps: {
        'title': title,
        'body': body,
        'isCorrect': isCorrect
      }
    });

    modal.backdropDismiss = false;

    modal.onDidDismiss().then(() => {
      if (navigate === 'home') {
        this.router.navigate(['home']);
      } else if (navigate) {
        this.router.navigate(['home', navigate]);
      }

    })

    return await modal.present();
  }

  async presentMatchModal(title: string, body: string) {

    const modal = await this.modalCtrl.create({
      component: MatchMessageAlertComponent,
      cssClass: 'generic-message-alert',
      componentProps: {
        'title': title,
        'body': body,
      }
    });

    modal.backdropDismiss = false;

    return await modal.present();
  }

  public async showLoading(transparent?: boolean | number | string, isMatchmaking: boolean = false) {

    if (typeof transparent == 'boolean') {
      this._showLoading(0, false, isMatchmaking);
    } else if (typeof transparent == 'number') {
      this._showLoading(transparent, false, isMatchmaking);
    } else if (typeof transparent == 'string') {
      this._showLoading(0, true, isMatchmaking);
    } else {
      this._showLoading(0.8, false, isMatchmaking);
    }
  }

  /**
   *
   * 
   * @param number opacity
   * @param boolean [spinner=false]
   * @returns
   * @memberof IonicLoaderManagerService
   */
  private async _showLoading(opacity: number, spinner: boolean = false, isMatchmaking: boolean = false) {
    if (this._isLoading) return;
    this._isLoading = true;

    let enterFrom = 0.01;
    let enterTo = opacity
    if (enterTo === 0) {
      enterFrom = enterTo;
    }

    this.isMatchmaking = isMatchmaking

    // soluzione che fa schifo, ma è una soluzione.
    if (this.isMatchmaking) {


      return await this._loadingCtrl
        .create({
          // message: '<hr/><hr/><hr/><hr/>',
          message: opacity === 0 && !spinner ? undefined : '<ion-img src="/assets/spinner.gif" alt="loading..."></ion-img><ion-button id="buttonCancel">ANNULLA</ion-button>',
          spinner: null,
          cssClass: "myLoading",
          enterAnimation: ((baseEl: HTMLIonLoadingElement) => {
            const baseAnimation = createAnimation();
            const backdropAnimation = createAnimation();
            const wrapperAnimation = createAnimation();
            let btnCancel = document.getElementById("buttonCancel");
            if (btnCancel) {
              btnCancel.addEventListener('click', () => {
                this.subStatusMatch.unsubscribe();
                if (this.matchWithFriend) {
                  // TODO: add function to delete invite
                  this.cancelInvite(this.dataToCancelInvite.inviteId, this.dataToCancelInvite.nickname);
                  this.hideLoading();
                } else {
                  this.stopMatchmaking();

                  this.hideLoading();
                  this.router.navigate(['home']);
                }
              });
            }
            backdropAnimation
              .addElement(baseEl.querySelector('ion-backdrop')!)
              .fromTo('opacity', enterFrom, enterTo);
            wrapperAnimation
              .addElement(baseEl.querySelector('.loading-wrapper')!)
              .keyframes([
                { offset: 0, opacity: 0.01, transform: 'scale(1.1)' },
                { offset: 1, opacity: 1, transform: 'scale(1)' }
              ]);
            return baseAnimation
              .addElement(baseEl)
              .easing('ease-in-out')
              .duration(200)
              .addAnimation([backdropAnimation, wrapperAnimation]);
          }) as any,
          leaveAnimation: ((baseEl: HTMLIonLoadingElement) => {
            const baseAnimation = createAnimation();
            const backdropAnimation = createAnimation();
            const wrapperAnimation = createAnimation();
            backdropAnimation
              .addElement(baseEl.querySelector('ion-backdrop')!)
              .fromTo('opacity', enterFrom, 0);
            wrapperAnimation
              .addElement(baseEl.querySelector('.loading-wrapper')!)
              .keyframes([
                { offset: 0, opacity: 0.99, transform: 'scale(1)' },
                { offset: 1, opacity: 1, transform: 'scale(0.9)' }
              ]);
            return baseAnimation
              .addElement(baseEl)
              .easing('ease-in-out')
              .duration(200)
              .addAnimation([backdropAnimation, wrapperAnimation]);
          }) as any
        })
        .then(a => {
          a.present().then(() => {
            if (!this._isLoading) {
              a.dismiss().then(() => {
                this._isLoading = false;
              });
            }
          });
        });
    } else {
      return await this._loadingCtrl
        .create({
          // message: '<hr/><hr/><hr/><hr/>',
          message: opacity === 0 && !spinner ? undefined : '<ion-img src="/assets/spinner.gif" alt="loading..."></ion-img>',
          spinner: null,
          cssClass: "myLoading",
          enterAnimation: ((baseEl: HTMLIonLoadingElement) => {
            const baseAnimation = createAnimation();
            const backdropAnimation = createAnimation();
            const wrapperAnimation = createAnimation();
            backdropAnimation
              .addElement(baseEl.querySelector('ion-backdrop')!)
              .fromTo('opacity', enterFrom, enterTo);
            wrapperAnimation
              .addElement(baseEl.querySelector('.loading-wrapper')!)
              .keyframes([
                { offset: 0, opacity: 0.01, transform: 'scale(1.1)' },
                { offset: 1, opacity: 1, transform: 'scale(1)' }
              ]);
            return baseAnimation
              .addElement(baseEl)
              .easing('ease-in-out')
              .duration(200)
              .addAnimation([backdropAnimation, wrapperAnimation]);
          }) as any,
          leaveAnimation: ((baseEl: HTMLIonLoadingElement) => {
            const baseAnimation = createAnimation();
            const backdropAnimation = createAnimation();
            const wrapperAnimation = createAnimation();
            backdropAnimation
              .addElement(baseEl.querySelector('ion-backdrop')!)
              .fromTo('opacity', enterFrom, 0);
            wrapperAnimation
              .addElement(baseEl.querySelector('.loading-wrapper')!)
              .keyframes([
                { offset: 0, opacity: 0.99, transform: 'scale(1)' },
                { offset: 1, opacity: 1, transform: 'scale(0.9)' }
              ]);
            return baseAnimation
              .addElement(baseEl)
              .easing('ease-in-out')
              .duration(200)
              .addAnimation([backdropAnimation, wrapperAnimation]);
          }) as any
        })
        .then(a => {
          a.present().then(() => {
            if (!this._isLoading) {
              a.dismiss().then(() => {
                this._isLoading = false;
              });
            }
          });
        });
    }
  }

  stopMatchmaking() {
    const callable = this.firebaseFunction.httpsCallable('stopMatchmaking');
    const obs = callable({ difficulty: this.difficulty });

    obs.subscribe();
  }

  cancelInvite(inviteId, nickname) {
    const callable = this.firebaseFunction.httpsCallable('cancelInvite');
    const obs = callable({ inviteId: inviteId, nickname: nickname });

    obs.subscribe();
  }

  /**
   *
   *
   * @returns Promise<any>
   * @memberof IonicLoaderManagerService
   */
  public hideLoading(): Promise<any> {
    return new Promise((resolve) => {
      if (this._isLoading) {
        this._isLoading = false;
        try {
          this._loadingCtrl.dismiss().then(() => {
            resolve();
          })
        } catch (e) {
          resolve();
        }
      } else {
        resolve();
      }
    });
  }

  getRound(currentRound: number): string {
    if (currentRound === 1) {
      return 'Sedicesimi di finale';
    } else if (currentRound === 2) {
      return 'Ottavi di finale';
    } else if (currentRound === 3) {
      return 'Quarti di finale';
    } else if (currentRound === 4) {
      return 'Semifinale';
    } else if (currentRound === 5) {
      return 'Finale';
    }
    return '';
  }

  formatDate(UNIX_timestamp) {
    /*
        var a = new Date(UNIX_timestamp * 1000);
        var year = a.getFullYear();
        var month = a.getMonth() + 1
        var date = a.getDate();
        var hour = a.getHours().toString();;
        var min = a.getMinutes().toString();
        if (min.length == 1) min = "0" + min
        if (hour.length == 1) hour = "0" + hour
        var time = date + '/' + month + '/' + year + ' ' + hour + ':' + min;
        return time;
        */
    return moment.utc(UNIX_timestamp * 1000).tz("Europe/Rome").format("DD/MM/YYYY") + ' ' + moment.utc(UNIX_timestamp * 1000).tz("Europe/Rome").format("HH:mm (z)");

  }

  redirectToHome() {
    this.router.navigate(['home']);
  }

  get difficulty() {
    return this._difficulty;
  }

  set difficulty(difficulty: string) {
    this._difficulty = difficulty;
  }

  get matchWithFriend() {
    return this._matchWithFriend;
  }

  set matchWithFriend(nValue: boolean) {
    this._matchWithFriend = nValue;
  }

  get dataToCancelInvite() {
    return this._dataToCancelInvite;
  }

  set dataToCancelInvite(nValue: any) {
    this._dataToCancelInvite = nValue;
  }

}




